import * as Styled from './vocabulary-thumbnail.style';
import { ValidSpacings } from 'approot/shared/styles/spacing.style';
import InlineServerError from 'approot/errors/inline-server-error';
import { Box } from 'approot/shared/design-system/box/box.style';

const VocabularyImageRegenerateButton = ({
  disabled,
  onClick,
  error,
  $marginBottom = 16,
  label,
  loading,
  ...rest
}: {
  disabled: boolean;
  onClick: () => void;
  error: boolean;
  $marginBottom?: ValidSpacings;
  label: string;
  loading: boolean;
}) => {
  return (
    <Box $marginTop={16} $marginBottom={$marginBottom}>
      <Styled.VocabularyImageRegenerateButton
        disabled={disabled}
        onClick={onClick}
        isLoading={loading}
        {...rest}
      >
        {label}
      </Styled.VocabularyImageRegenerateButton>

      {error && (
        <InlineServerError
          centreText
          customError="The request timed out. Please try again."
        />
      )}
    </Box>
  );
};

export default VocabularyImageRegenerateButton;
